import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { actions, modalDialogState } from '../../state/src/modal-dialog-slice';
import { warningActions, warningModalDialogState } from '../../state/src/warning-modal-dialog-slice';

export const useModalDialog = () => {
  const dispatch = useDispatch();
  const state = useSelector(modalDialogState, shallowEqual);

  const openModalDialog = () => {
    if (state.isModalOpen === false) {
      dispatch(actions.openModalDialog());
    } else {
      return {
        type: 'NOOP',
      };
    }
  };

  const closeModalDialog = React.useCallback(() => {
    dispatch(actions.closeModalDialog());
  }, [dispatch]);

  return {
    ...state,
    openModalDialog,
    closeModalDialog,
  };
};

export const useWarningModalDialog = () => {
  const dispatch = useDispatch();
  const warningState = useSelector(warningModalDialogState, shallowEqual);

  const openWarningModalDialog = (otherArgs = {}) => {
    if (warningState.isModalOpen === false) {
      dispatch(warningActions.openWarningModalDialog(otherArgs));
    } else {
      return {
        type: 'NOOP',
      };
    }
  };

  const closeWarningModalDialog = React.useCallback(() => {
    dispatch(warningActions.closeWarningModalDialog());
  }, [dispatch]);

  return {
    warningState,
    openWarningModalDialog,
    closeWarningModalDialog,
  };
};
